module.exports = __webpack_public_path__ + "d27ab4727bbf2299defa15b74a3c4440.svg";